import {
    IhioDeliverCheckCodeRequestType,
    IhioPrescriptionAdmissionType,
    ihioPrescriptionAdmissionTypeInitialValues,
    IhioWrittenPrescriptionInfoType,
    IhioWrittenPrescriptionItemType,
    PrescriptionFillingInfoLocationState
} from "../../../types/ihioPrescriptionFilling";
import {useLocation} from "react-router-dom";
import {useGetIhioDeliverCheckCode} from "../../../hook/request/ihioPrescriptionFilling";
import {useEffect, useState} from "react";
import {v4 as uuidv4} from "uuid";
import PrescriptionFillingInfo
    from "../../components/ihioPrescriptionFilling/prescriptionFillingDetails/prescriptionFillingInfo/prescriptionFillingInfo";
import PrescriptionFillingWrittenPrescriptionDetails
    from "../../components/ihioPrescriptionFilling/prescriptionFillingDetails/prescriptionFillingInfo/prescriptionFillingWrittenPrescriptionDetails";
import PrescriptionItemsToFulfil
    from "../../components/ihioPrescriptionFilling/prescriptionFillingDetails/prescriptionItemsToFulfil/prescriptionItemsToFulfil";
import {general} from "../../../store/action";
import {connect} from "react-redux";
import FulfilPrescriptionModal
    from "../../components/ihioPrescriptionFilling/prescriptionFillingDetails/fulfilPrescriptionModal/fulfilPrescriptionModal";

type PrescriptionFillingDetailsProps = {
    handleShowModal: any;
}

const PrescriptionFillingDetails = ({
    handleShowModal
}: PrescriptionFillingDetailsProps) => {

    const location = useLocation()
    const locationState = location?.state as PrescriptionFillingInfoLocationState;

    const [prescriptionAdmissionData, setPrescriptionAdmissionData] = useState<IhioPrescriptionAdmissionType>(ihioPrescriptionAdmissionTypeInitialValues)
    const [writtenPrescriptionData, setWrittenPrescriptionData] = useState<IhioWrittenPrescriptionInfoType | null>(null)

    const [itemsToFulfil, setItemsToFulfil] = useState<Record<string, IhioWrittenPrescriptionItemType>>({})

    const [fulfilPrescriptionModalVisible, setFulfilPrescriptionModalVisible] = useState(false)

    const getIhioDeliverCheckCodeRequest = useGetIhioDeliverCheckCode();

    useEffect(() => {
        if(locationState) {
            setPrescriptionAdmissionData(locationState?.prescriptionAdmissionData)
            setWrittenPrescriptionData({
                ...locationState?.writtenPrescriptionData,
                items: locationState?.writtenPrescriptionData?.items?.map((item) => {
                    return {
                        ...item,
                        UUID: uuidv4()
                    }
                })
            });
        }
    }, [locationState]);

    const sendIhioDeliverCheckCodeRequest = async (item: IhioWrittenPrescriptionItemType, itemCount?: number) => {
        const otherItems = Object.values(itemsToFulfil) // Convert object to an array
            .filter((field: any) => field.UUID !== item?.UUID) // Filter out the current UUID
            .map((field: any) => field.checkCode) // Extract check codes
            .filter((checkCode: any) => checkCode); // Remove any undefined or null check codes

        const body: IhioDeliverCheckCodeRequestType = {
            patientNationalCode: prescriptionAdmissionData?.nationalCode,
            prescriptionTrackingCode: prescriptionAdmissionData?.trackingCode,
            itemCount: itemCount ? itemCount : ((item?.itemCount || 0) - determineRemainingItems(item)),
            irc: item?.irc || '',
            description: item?.description,
            activeDate: item?.activeDate,
            checkCodes: otherItems || []
        }
        return getIhioDeliverCheckCodeRequest.mutateAsync(body);
    }

    const determineRemainingItems = (item: IhioWrittenPrescriptionItemType) => {
        return item?.deliveredItems?.reduce((sum, item) => {

            return sum + (item.itemCount || 0);
        }, 0) || 0;
    }

    const handleAddItemToFulfil = async (UUID: string, item: IhioWrittenPrescriptionItemType) => {

        const result = await sendIhioDeliverCheckCodeRequest(item)

        setItemsToFulfil(prevState => ({
            ...prevState,
            [UUID]: {
                ...item,
                ...result?.data.result,
                itemsToBeDelivered: ((item?.itemCount || 0) - determineRemainingItems(item))
            }
        }))
    }

    const handleRemoveItemFromFulfil = (UUID: string) => {
        setItemsToFulfil((prevState: any) => {
            const newState = { ...prevState }; // Create a shallow copy of the current object state
            delete newState[UUID]; // Delete the item by its UUID
            return newState; // Return the updated object
        });
    }



    const handleUpdateRowItem = async (UUID: string, item: IhioWrittenPrescriptionItemType, itemCount: number) => {

        const result = await sendIhioDeliverCheckCodeRequest(item, itemCount)

        setItemsToFulfil(prevState => ({
            ...prevState,
            [UUID]: {
                ...item,
                ...result?.data.result,
                itemsToBeDelivered: result?.status === 200 ? itemCount : ((item?.itemCount || 0) - determineRemainingItems(item))
            }
        }))

        return result?.status
    }


    return (
        <>
            <PrescriptionFillingInfo
                prescriptionAdmissionData={prescriptionAdmissionData}
                writtenPrescriptionData={writtenPrescriptionData}
            />
            <PrescriptionFillingWrittenPrescriptionDetails
                prescriptionAdmissionData={prescriptionAdmissionData}
                writtenPrescriptionData={writtenPrescriptionData}
                itemsToFulfil={itemsToFulfil}
                handleAddItemToFulfil={handleAddItemToFulfil}
                handleRemoveItemFromFulfil={handleRemoveItemFromFulfil}
                isLoading={getIhioDeliverCheckCodeRequest?.isPending}
            />
            <PrescriptionItemsToFulfil
                prescriptionAdmissionData={prescriptionAdmissionData}
                writtenPrescriptionData={writtenPrescriptionData}
                itemsToFulfil={itemsToFulfil}
                handleRemoveItemFromFulfil={handleRemoveItemFromFulfil}
                handleUpdateRowItem={handleUpdateRowItem}
                isLoading={getIhioDeliverCheckCodeRequest?.isPending}
            />
            {Object.keys(itemsToFulfil)?.length > 0 && (
                <div className={'d-flex align-items-center justify-content-end my-3'}>
                    <div
                        className={'btn btn-primary rounded rounded-3'}
                        onClick={() =>
                            handleShowModal('fulfilPrescriptionModal', {prescriptionAdmissionData: prescriptionAdmissionData, itemsToFulfil: itemsToFulfil})
                        }
                    >
                        تایید انجام خدمت
                    </div>
                </div>
            )}
            <FulfilPrescriptionModal/>
        </>
    )
}


const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionFillingDetails);